import { render, staticRenderFns } from "./tickFilter.vue?vue&type=template&id=66b81cec&scoped=true&"
import script from "./tickFilter.vue?vue&type=script&lang=js&"
export * from "./tickFilter.vue?vue&type=script&lang=js&"
import style0 from "./tickFilter.vue?vue&type=style&index=0&id=66b81cec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b81cec",
  null
  
)

export default component.exports